import { HistoryStore as BaseHistoryStore } from '@bn-games/history-core';
import type { GameRecord } from './types.js';
import { HISTORY_SCHEMA_VERSION } from './types.js';

// Per-app subclass pre-configures @bn-games/history-core's generic FIFO list
// with checkers' storage key + schema version + shape predicate. Callers
// continue to do `new HistoryStore()` without thinking about config.
export class HistoryStore extends BaseHistoryStore<GameRecord> {
  constructor() {
    super({
      storageKey: 'checkers-history',
      schemaVersion: HISTORY_SCHEMA_VERSION,
      isValid: (parsed) => Array.isArray(parsed.moves),
    });
  }
}
